import { useState } from "react";
import { animeList } from "@/mocks/anime";
import AnimeCard from "./AnimeCard";

const tabs = ["全部", "动物拟人番", "兽耳萌番", "宠物日常", "猫狗动画"] as const;

export default function NewReleases() {
  const [active, setActive] = useState<string>("全部");

  const list = active === "全部" ? animeList : animeList.filter((a) => a.tag === active);

  return (
    <section id="new" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-sparkling-2-line"></i>
              新番速递
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
              按类型逛遍萌宠番
            </h2>
          </div>
          <div className="flex flex-wrap items-center gap-1 rounded-full bg-background-200/80 p-1">
            {tabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors cursor-pointer ${
                  active === tab
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-700"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {list.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}